export function sanitizeUrl(url: string): string {
  let sanitizedUrl = url;

  sanitizedUrl = sanitizedUrl.replace(/\/\/pages/g, '/pages');

  if (url.endsWith('/')) {
    sanitizedUrl = sanitizedUrl.slice(0, -1);
  }

  return sanitizedUrl;
}
